import Model from '~/models/base/Model';

/**
 * class representing Action Result
 * @extends Model
 */
export default class ActionResult extends Model {
    // todo: looks unused, check its usefulness
    static _urlResult = `${Model._url}/automatic-actions`;

    static getLatestByType(objectId, incidentId) {
        const requestUrl = `${Model._url}/${
            incidentId ? `incidents/${incidentId}/objects` : 'entities'
        }/${objectId}/results/`;
        const requestPayload = { distinct: 1 };
        return this.api.post(requestUrl, requestPayload);
    }

    static getResultList(objectId, incidentId, start, step) {
        const requestUrl = `${Model._url}/${
            incidentId ? `incidents/${incidentId}/objects` : 'entities'
        }/${objectId}/results/`;
        const requestPayload = { start: start, step: step, distinct: 0 };
        return this.api.post(requestUrl, requestPayload);
    }

    static getTestResult(uniqueLabel, internalName, resourceId, format) {
        const requestUrl = `${
            APP_URL.automation
        }/testYamlAction/${uniqueLabel}/${internalName}/${resourceId}/${
            (format ?? 'json') === 'json' ? 'json/' : ''
        }`;
        return this.api.get(requestUrl);
    }

    static get(resultId, format) {
        const requestUrl = `${
            APP_URL.automation
        }/automatic-actions/result/${resultId}/${
            (format ?? 'json') === 'json' ? 'json/' : ''
        }`;
        return this.api.get(requestUrl);
    }
}
